/* Something worth saying once, folded away until asked for.
 *
 * These drawers accumulated explanations — which columns the nightly sync
 * overwrites, why a licence row cannot be deleted, what a promoted column does.
 * Every one of them is worth reading the first time and noise by the third, and
 * they were all sitting open, permanently, above the buttons.
 *
 * Deleting them is the wrong fix: the person who has not read one yet is
 * exactly the person about to type into a field the sync will overwrite at
 * 02:00. So they fold. Closed by default, one line of what it is about, and the
 * whole thing is a button so it is reachable by keyboard like anything else.
 */

import { useId, useState, type ReactNode } from 'react';
import s from './screens.module.scss';

export function Explain({
  title,
  icon = 'ti-info-circle',
  children,
}: {
  /** What the note is about, in a few words. Read closed far more often than
      open, so it has to carry the gist on its own. */
  title: string;
  icon?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const bodyId = useId();

  return (
    <div className={s.explain}>
      <button
        type="button"
        className={s.explainToggle}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={bodyId}
      >
        <i className={`ti ${icon}`} aria-hidden />
        <span className={s.explainGrow}>{title}</span>
        <i className={`ti ${open ? 'ti-chevron-up' : 'ti-chevron-down'}`} aria-hidden />
      </button>
      {open && (
        <div className={s.explainBody} id={bodyId}>
          {children}
        </div>
      )}
    </div>
  );
}
